import React, { useEffect, useState } from "react";
import { Card, Col, Container, Row } from "react-bootstrap";
import { useParams } from "react-router-dom";
import { studySiteDataEntryServices } from "../../../APIServices/studySiteDataEntryServices";
import { PageLoader } from "../../../Components/NoDataFoundTable/NoDataFoundTable";
import { MdMarkChatUnread, MdMarkChatRead, MdOutlineAccessTime } from "react-icons/md";
import { RiRefreshLine } from "react-icons/ri";
import { BsCheck2All, BsGraphUp, BsClockHistory } from "react-icons/bs";
import { PiWarning } from "react-icons/pi";
import { FaChartLine } from "react-icons/fa";
import { TbCalendarPlus, TbCalendarCheck } from "react-icons/tb";

const QueryOverview = () => {
  const [queryListCount, setQueryListCount] = useState(0);
  const [totalOpenQuery, setTotalOpenQuery] = useState(0);
  const [totalClosedQuery, setTotalClosedQuery] = useState(0);
  const [totalCancelQuery, setTotalCancelQuery] = useState(0);
  const [totalAnsweredQuery, setTotalAnsweredQuery] = useState(0);
  const [totalAutoQuery, setTotalAutoQuery] = useState(0);
  const [totalManualQuery, setTotalManualQuery] = useState(0);
  const [todayTotalOpenQuery, setTodayTotalOpenQuery] = useState(0);
  const [todayTotalCloseQuery, setTodayTotalCloseQuery] = useState(0);
  const [todayTotalCancelQuery, setTodayTotalCancelQuery] = useState(0);
  const [totalOverdueQuery, setTotalOverdueQuery] = useState(0);
  const [totalReopenQuery, setTotalReopenQuery] = useState(0);
  const [oldestOpenQuery, setOldestOpenQuery] = useState("");
  const [totalAvarageQueryCloseTime, setTotalAvarageQueryCloseTime] = useState("");
  const [totalMedianQueryCloseTime, setTotalMedianQueryCloseTime] = useState("");
  const [totalAverageQueryBySubject, setTotalAverageQueryBySubject] = useState(0);
  const [totalAverageQueryByForm, setTotalAverageQueryByForm] = useState(0);
  const [loading, setLoading] = useState(false);
  let { studyId } = useParams();
  const StudyMode = JSON.parse(localStorage.getItem("StudyMode"));

  const getStudyFormFieldQueryOverview = async (e) => {
    setLoading(true);
    let userData = {};
    userData.studyId = studyId;
    userData.mode = StudyMode;
    let data = await studySiteDataEntryServices.getStudyFormFieldQueryOverview(
      userData
    );
    if (data === "AbortError") {
      setLoading(true);
    } else {
      setQueryListCount(data?.count || 0);
      setTotalOpenQuery(data?.totalOpenQuery || 0);
      setTotalClosedQuery(data?.totalClosedQuery || 0);
      setTotalCancelQuery(data?.totalCancelQuery || 0);
      setTotalAnsweredQuery(data?.totalAnsweredQuery || 0);
      setTotalAutoQuery(data?.totalAutoQuery || 0);
      setTotalManualQuery(data?.totalManualQuery || 0);
      setTodayTotalOpenQuery(data?.totalTodayOpenQueryCount || 0);
      setTodayTotalCloseQuery(data?.totalTodayCloseQueryCount || 0);
      setTodayTotalCancelQuery(data?.totalTodayCancelQueryCount || 0);
      setTotalOverdueQuery(data?.totalOverdueQueryCount || 0);
      setTotalReopenQuery(data?.totalReopenQueryCount || 0);
      setOldestOpenQuery(data?.oldestOpenQuery);
      setTotalAvarageQueryCloseTime(data?.totalAvarageQueryCloseTime);
      setTotalMedianQueryCloseTime(data?.totalMedianQueryCloseTime);
      setTotalAverageQueryBySubject(data?.totalAverageQueryBySubject || 0);
      setTotalAverageQueryByForm(data?.totalAverageQueryByForm || 0);
      setLoading(false)
    }
  };

  const overviewCards = [
    {
      title: "Total Queries",
      value: queryListCount,
      subtitle: "All queries generated in study",
      icon: <BsGraphUp className="bg-white text-dark shadow-sm" />,
    },
    {
      title: "Open Queries",
      value: totalOpenQuery,
      subtitle: "Pending site response",
      icon: <MdMarkChatUnread className="bg-white text-primary shadow-sm" />,
    },
    {
      title: "Answered Queries",
      value: totalAnsweredQuery,
      subtitle: "Pending CRA/DM review",
      icon: <BsCheck2All className="bg-white text-info shadow-sm" />,
    },
    {
      title: "Closed Queries",
      value: totalClosedQuery,
      subtitle: "Reviewed and closed",
      icon: <MdMarkChatRead className="bg-white text-success shadow-sm" />,
    },
    {
      title: "Cancelled Queries",
      value: totalCancelQuery,
      subtitle: "Reviewed and cancelled",
      icon: <MdMarkChatRead className="bg-white text-warning shadow-sm" />,
    },
    {
      title: "Overdue Queries",
      value: totalOverdueQuery,
      subtitle: "Beyond SLA timeline",
      icon: <PiWarning className="bg-white text-danger shadow-sm" />,
    },
    {
      title: "Re-opened Queries",
      value: totalReopenQuery,
      subtitle: "Opened again after closure",
      icon: <RiRefreshLine className="bg-white text-warning shadow-sm" />,
    },
    {
      title: "Avg Resolution",
      value: totalAvarageQueryCloseTime,
      subtitle: "Average closure time",
      icon: <MdOutlineAccessTime className="bg-white text-info shadow-sm" />,
    },
    {
      title: "Median Resolution",
      value: totalMedianQueryCloseTime,
      subtitle: "Median closure time",
      icon: <BsClockHistory className="bg-white text-primary shadow-sm" />,
    },
    {
      title: "Oldest Open Query",
      value: oldestOpenQuery,
      subtitle: "Longest unresolved query",
      icon: <PiWarning className="bg-white text-danger shadow-sm" />,
    },
    {
      title: "Query Rate / Subject",
      value: totalAverageQueryBySubject,
      subtitle: "Queries per enrolled subject",
      icon: <FaChartLine className="bg-white text-secondary shadow-sm" />,
    },
    {
      title: "Query Rate / Form",
      value: totalAverageQueryByForm,
      subtitle: "Queries per completed form",
      icon: <FaChartLine className="bg-white text-secondary shadow-sm" />,
    },
    {
      title: "Created Today",
      value: todayTotalOpenQuery,
      subtitle: "New queries today",
      icon: <TbCalendarPlus className="bg-white text-primary shadow-sm" />,
    },
    {
      title: "Closed Today",
      value: todayTotalCloseQuery,
      subtitle: "Queries closed today",
      icon: <TbCalendarCheck className="bg-white text-success shadow-sm" />,
    },
    {
      title: "Cancelled Today",
      value: todayTotalCancelQuery,
      subtitle: "Queries cancelled today",
      icon: <TbCalendarCheck className="bg-white text-warning shadow-sm" />,
    },
    // {
    //   title: "DB Lock Readiness",
    //   value: "12.3%",
    //   subtitle: "Subjects without open queries",
    //   icon: <PiDatabase className="bg-white text-danger shadow-sm" />,
    // },
  ];

  useEffect(() => {
    getStudyFormFieldQueryOverview();
  }, []);

  return (
    <>
      <div className="overflow-auto" style={{ height: "calc(100vh - 145px)" }}>
        {loading ? (
          <PageLoader />
        ) :
          <Container fluid>
            <Row className="g-2 py-2">
              {overviewCards?.map((item, index) => (
                <Col xl={3} lg={4} md={6} sm={12} key={index}>
                  <Card className="app-card bg-light border h-100">
                    <Card.Body>
                      <div className="d-flex gap-3">
                        <div className="study_icopn">
                          {item.icon}
                        </div>
                        <div>
                          <Card.Title style={{ fontSize: 16 }}>{item.title}</Card.Title>
                          <Card.Text className="m-0">{item.value || "0"}</Card.Text>
                          <Card.Text style={{ fontSize: 11 }}>{item.subtitle}</Card.Text>
                        </div>
                      </div>
                    </Card.Body>
                  </Card>
                </Col>
              ))}
            </Row>
          </Container>
        }
      </div>
    </>
  );
};

export default QueryOverview;
